export default "__VITE_ASSET__CVCjB5FQ__"